import { BUSINESS_FILTER_DISABLED, BUSINESS_FILTER_ENABLED } from '../actions/business_filter'
import { LOGOUT_SUCCESS } from '../actions'

export function businessFilter(state = { businessFilter: null }, action) {
  switch (action.type) {
    case BUSINESS_FILTER_ENABLED:
      return { ...state, businessFilter: action.businessFilter }
    case BUSINESS_FILTER_DISABLED:
      return { ...state, businessFilter: action.businessFilter }
    case LOGOUT_SUCCESS:
      return { ...state, businessFilter: null }
    default:
      return state
  }
}
